import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { fetchCollection, createLock } from '../../common/redux/collectionActions'
import LockInput from './Inputs/LockInput'
import AdminsInput from './Inputs/AdminsInput'
import { swalError } from '../../common/components/Swaler'

const valSufficient = (val) => {
    return (!!val && val.length > 0)
}

const defaultState = {
    input: {
        primaryLock: { controller: { open_duration: 5000, port_id: 0, qlocx_id: '' }, address: { street: '', zip: '', city: '' } },
        secondaryLock: { controller: { open_duration: 7000, port_id: 0 }, qlocx_id: '' },
        admins: []
    },
    inactivatedFields: []
}

class CreateContainer extends Component {
    constructor(p) {
        super(p)

        this.updateInput = this.updateInput.bind(this)
        this.getFields = this.getFields.bind(this)
        this.updateAdmins = this.updateAdmins.bind(this)
        this.removeField = this.removeField.bind(this)
        this.submit = this.submit.bind(this)

        this.state = defaultState
    }

    componentWillMount() {
        if (!this.props.admin) this.props.fetchCollection("admin")
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getFields() {
        return {
            primaryLock: {
                label: 'Byggdörr',
                element: <LockInput controller={this.state.input.primaryLock.controller} address={this.state.input.primaryLock.address} onChange={(e, subField) => this.updateInput(e, subField, 'primaryLock')} />
            },
            secondaryLock: {
                label: 'Transportörsdörr',
                element: <LockInput controller={this.state.input.secondaryLock.controller} disabledFields={['owner', 'custom_name', 'AddressInput']} onChange={(e, subField) => this.updateInput(e, subField, 'secondaryLock')} />,
                canInactivate: true
            },
            admins: {
                label: 'Administratörer',
                element: <AdminsInput updateAdmins={this.updateAdmins} />
            }
        }
    }

    updateInput(e, child, parent) {
        var input = { ...this.state.input }

        if (child) {
            input[parent][child][e.target.name] = e.target.value
        } else {
            input[parent][e.target.name] = e.target.value
        }

        this.setState({ input })
    }

    updateAdmins(list) {
        const input = { ...this.state.input }
        input.admins = list
        this.setState({ input })
    }

    removeField(fieldName) {
        this.setState((prevState) => ({ inactivatedFields: prevState.inactivatedFields.concat(fieldName) }))
    }

    submit() {
        const { input, inactivatedFields } = this.state

        const PL = input.primaryLock
        const SL = input.secondaryLock
        if (!valSufficient(PL.custom_name)) return swalError('Projektnamn saknas')
        if (!valSufficient(PL.location)) return swalError('Beskrivning av placering saknas')
        if (!valSufficient(PL.owner)) return swalError('Administratör saknas')
        if (!valSufficient(PL.address.street)) return swalError('Gatuadress saknas')
        if (!valSufficient(PL.address.zip)) return swalError('Postnummer saknas')
        if (!valSufficient(PL.address.city)) return swalError('Stad saknas')

        if (SL) {
            if (!valSufficient(PL.location)) return swalError('Beskrivning av placering saknas hos Speditörsdörr')
        }

        const cleanedInput = Object.entries(input).reduce((acc, [key, val]) => {
            if (inactivatedFields.includes(key)) return acc

            acc[key] = val
                
            return acc
        }, {})

        this.props.createLock(cleanedInput).then((r) => {
            if (r) {
                this.setState(defaultState)
            }
        })
    }

    render() {
        const fields = this.getFields()

        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {Object.keys(fields).map(key => {
                            const val = fields[key]
                            if (this.state.inactivatedFields.indexOf(key) > -1) return null

                            return (
                                <div key={key}>
                                    <Row>
                                        <Col xs={2} md={2} sm={2} style={{ textAlign: 'center' }}>
                                            <h3>{val.label}</h3>
                                        </Col>
                                        <Col xs={10} md={10} sm={10} style={{ textAlign: 'left' }}>
                                            {val.canInactivate == true ? <div className="submitUserForm" style={{ fontWeight: 400, width: '100%', fontSize: 'medium', padding: 0, border: 0, marginTop: 20, width: '30%', float: 'left' }} onClick={() => this.removeField(key)}>Det finns ingen {val.label}</div> : null}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12} sm={12}>
                                            {val.element}
                                        </Col>
                                    </Row>
                                    <hr />
                                </div>
                            )
                        })}

                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} sm={12}>
                        <div className="submitUserForm" style={{ fontWeight: 400, padding: 0, border: 0 }} onClick={this.submit}>Spara</div>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

const mapProps = state => {
    return {
        admin: state.collectionData.admin
    }
}

const mapDispatch = dispatch => {
    return {
        fetchCollection: (...args) => dispatch(fetchCollection(...args)),
        createLock: (...args) => dispatch(createLock(...args))
    }
}

export default connect(mapProps, mapDispatch)(CreateContainer)